<template>
  <div>
    <right-panel id="sidebar-member-form" width="800px" @hidden="rightPanelClosed">
      <div class="p-3">
        <MemberForm v-if="editedEntity" />
      </div>
    </right-panel>

    <div class="card rounded">
      <div class="card-body">
        <div class="container-fluid">
          <h2 class="mb-4">
            <letter-avatar :name="editedOrganization.name" :image="editedOrganization.logo" variant="secondary" />
            <span class="text-main ml-2"> {{ editedOrganization.name }}</span>
            {{ $t("organization.members.text") }}
          </h2>

          <content-loading v-if="isLoading" />
          <div v-if="pagination && pagination.docs.length > 0">
            <b-row v-for="item in pagination.docs" :key="item._id" class="border-top">
              <b-col md="4" class="member">
                <div class="member--img mt-1">
                  <letter-avatar :name="item.name" :image="item.avatar" variant="secondary"> </letter-avatar>
                </div>
                <div class="member--info mt-1">
                  <span v-if="item.isOwner" v-b-tooltip.hover :title="$t('organization.owner')" class="text-warning">
                    <i class="bx bxs-star"></i>
                  </span>
                  {{ item.name }}
                  <div class="member--mail">{{ item.email }}</div>
                </div>
              </b-col>

              <b-col md="5" class="pt-4">
                <div class="member--roles mt-2">
                  <div class="member--roles--tags">
                    <div v-for="role in item.roles" :key="item._id + role._id" class="mb-1">
                      <span class="badge badge-light border border-secondary p-1 ml-1">
                        {{ role.name | translate }}
                      </span>
                    </div>
                  </div>
                </div>
              </b-col>

              <b-col md="1" class="pt-4">
                <div class="">
                  <span v-if="!item.accessable" class="badge pill badge-soft-danger border border-danger">
                    {{ $t("organization.inaccessable") }}
                  </span>
                  <span v-else class="badge pill badge-soft-success border border-success">
                    {{ $t("organization.accessable") }}
                  </span>
                </div>
              </b-col>
              <b-col md="1" class="pt-4">
                <div>
                  <span v-if="!item.active" class="badge pill badge-soft-danger border border-danger" v-b-tooltip.hover :title="$t('common.contact-with-support')">
                    {{ $t("common.no") }}
                  </span>
                  <span v-else class="badge pill badge-soft-success border border-success">
                    {{ $t("common.yes") }}
                  </span>
                </div>
              </b-col>
              <b-col md="1" class="pt-4">
                <div>
                  <i class="bx bx-pencil hand" @click="edit(item)" v-b-toggle="'sidebar-member-form'"> </i>
                </div>
              </b-col>
            </b-row>
          </div>
        </div>

        <empty v-if="!isLoading && pagination && pagination.docs.length == 0">
          <h5 class="text-center">
            {{ $t("common.not-found") }}
          </h5>
        </empty>

        <div class="mt-4">
          <sweet-button class="mr-4" v-b-modal="'invite-member'" :loading="isUpdating" variant="link" icon="bx bx-plus" size="sm" buttonClass="mt-1 text-white btn-main">
            {{ $t("organization.invite") }}
          </sweet-button>

          <sweet-button v-b-modal="'import-members'" :loading="isUpdating" variant="link" icon="bx bx-plus" size="sm" buttonClass="mt-1 text-white btn-main">
            {{ $t("workspace.import-users") }}
          </sweet-button>
        </div>

        <modal id="invite-member" :title="$t('organization.invite')">
          <organization-invite-member :organization="editedOrganization" store="managementOrganization" @closeForm="form()" />
        </modal>
        <modal id="import-members" :title="$t('workspace.import-users')"> <OrganizationBulkInvite store="managementOrganization" @onSent="paginate()"/></modal>

        <template v-if="pagination">
          <div class="d-flex justify-content-center my-3">
            <ul class="pagination pagination-rounded mb-0">
              <b-pagination v-model="request.options.page" :total-rows="pagination.totalDocs" :per-page="pagination.limit" limit="10" size="sm"></b-pagination>
            </ul>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import Modal from "@c/modal.vue";
import MemberForm from "./management-organization-member-form";
import OrganizationBulkInvite from "./organization-bulk-invite";
import OrganizationInviteMember from "./organization-invite-member";

export default {
  components: { MemberForm, OrganizationBulkInvite, OrganizationInviteMember, Modal },
  data() {
    return {
      request: {
        options: { page: 1, limit: 10, sort: { name: "asc" } },
        query: {},
      },
    };
  },
  watch: {
    request: {
      deep: true,
      immediate: true,
      handler() {
        this.debounce(() => this.paginate());
      },
    },
    organization: {
      deep: true,
      handler() {
        this.paginate();
      },
    },
  },

  computed: {
    pagination() {
      return this.$store.getters["managementOrganizationMember/pagination"];
    },
    editedOrganization() {
      return this.$store.getters["managementOrganization/editedOrganization"];
    },
    editedEntity() {
      return this.$store.getters["managementOrganizationMember/editedEntity"];
    },
    isLoading() {
      return this.$store.getters["managementOrganizationMember/isLoading"];
    },
    isUpdating() {
      return this.$store.getters["managementOrganizationMember/isUpdating"];
    },
  },

  methods: {
    paginate() {
      this.$store.dispatch(`managementOrganizationMember/paginateWith`, { pagination: this.request, organizationId: this.editedOrganization?._id });
    },

    edit(data) {
      this.$store.commit("managementOrganizationMember/editedEntity", data);
    },

    rightPanelClosed() {
      this.paginate();
      this.$store.dispatch("managementOrganizationMember/resetForm");
    },
    form() {
      this.paginate();
      this.$bvModal.hide("invite-member");
    },
  },
};
</script>
<style lang="scss" scoped>
@import url("./organization-members.scss");
</style>
